export default {"src":"/_next/static/media/polygon.dc26c2d4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};